module.exports = __webpack_public_path__ + "static/media/file-medical.3fda3676.svg";